<template>
  <div class="shoping-trolley">
    <nav-bar
      :edit-pattern="editPattern"
      :show-edit="!isEmpty && shopingCartList.length"
      :title="navBar.title"
      @edit="toggleEditHandler"
      @finished-edit="toggleEditHandler"
      class="nav-bar"
      left-text
    ></nav-bar>
    <sticky offset-top="0.88rem">
      <div class="tabs">
        <div class="tab-item" :class="{'current': current == index}" @click="switchTab(index)" v-for="(tab, index) in tabs" :key="index">
          {{ tab.title }}
        </div>
      </div>
    </sticky>
    <div v-show="!isEmpty && shopingCartList.length">
      <msg @close-msg="toggleShowMsgStatus" v-model="showMsg"></msg>
      <div class="shoping-trolley-wrapper">
        <div
          :key="index"
          class="shoping-trolley-platfrom"
          v-for="(platfromDetails, index) in shopingCartList"
        >
          <div class="platform-title van-hairline--bottom">
            <div class="platform-status">
              <checkbox
                :checked="platfromDetails.checkStatus"
                :disabled="false"
                :gid="0"
                :platform="platfromDetails.platform.name"
                @change="checkChange"
              ></checkbox>
            </div>
            <span>{{ platfromDetails.platform.brand }}</span>
            <button
              @click="viewJdPrice(platfromDetails.platform.name)"
              class="view-jd-price"
              v-if="
                platfromDetails.platform.name === 'jd' ||
                  platfromDetails.platform.name === 'yanxuan' ||
                  platfromDetails.platform.name === 'suning'
              "
            >
              查看{{ platfromDetails.platform.name | viewPriceName }}价
            </button>
          </div>
          <div class="platform-product-lists">
            <ul class="platform-product-lists-wrapper">
              <li
                :key="index"
                class="platform-product-details"
                v-for="(sku, index) in platfromDetails.sku_list"
              >
                <div class="sku-checked">
                  <checkbox
                    :checked="sku.checkStatus"
                    :disabled="false"
                    :gid="sku.sku_id"
                    :platform="platfromDetails.platform.name"
                    @change="skuCheckChange"
                  ></checkbox>
                </div>
                <a
                  @click="jumpDetails(sku.item_id, sku.sku_id, sku.platform)"
                  class="jump-details van-hairline--bottom"
                  href="javascript:;"
                >
                  <div class="sku-details">
                    <div class="sku-img van-hairline--surround">
                      <img :key="sku.sku_id" v-lazy="sku.pic_url" />
                      <div class="sku-img-mask" v-show="sku.problem">
                        {{ sku.problem }}
                      </div>
                    </div>
                    <div class="sku-intro">
                      <div class="sku-title">{{ sku.name }}</div>
                      <!-- <div
                        class="sku-hint"
                        v-if="!sku.is_flj && !canUseGoldStatus"
                      >
                        该商品福利金不可用
                      </div> -->
                      <!-- gold_type -->
                      <div class="sku-hint" v-if='sku.is_type'>
                        <i class="gold_type" :class="Number(sku.is_type)===1?'red':' '" >{{Number(sku.is_type)===1?'可用福利金':(Number(sku.is_type)===2?'可用爱心币':'')}}</i>
                      </div>
                      <div class="sku-name" v-show="sku.attr_list">
                        <span>
                          <em
                            :key="index"
                            v-for="(item, index) in sku.attr_list"
                            >{{ item.attr_value.value }}
                          </em>
                        </span>
                      </div>
                      <div class="sku-price">
                        ¥
                        <em>{{ sku.market_price }}</em>
                      </div>
                    </div>
                    <div @click.stop class="sku-stepper">
                      <div class="sku-tips" v-if="sku.lowest_buy > 1">
                        ( {{ sku.lowest_buy }}件起购 )
                      </div>
                      <stepper
                        :disable-input="false"
                        :integer="true"
                        async-change
                        :max="sku.platform === 'jd' ? '99' : '999999'"
                        :min="
                          sku.activity &&
                            sku.activity.rule.code
                              | skuMinNum(sku.lowest_buy, sku.number)
                        "
                        :step="sku.activity && sku.activity.rule.code | skuStep"
                        :value="sku.number"
                        @minus="skuMinus(sku)"
                        @overlimit="
                          disabledEvent(
                            $event,
                            sku.activity && sku.activity.rule.code,
                            sku.number
                          )
                        "
                        @plus="skuPlus(sku)"
                        @blur="skuBlur($event, sku)"
                        class="shoping-sku-stepper"
                        input-width="35"
                      ></stepper>
                    </div>
                    <button
                      @click.stop="delSimpleSku(sku.sku_id, sku.platform)"
                      class="del-simple-sku"
                    ></button>
                  </div>
                  <p class="sku-status" v-show="sku.problem">
                    <span></span>
                    商品出现{{ sku.problem }}, 暂无法购买
                  </p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        class="shoping-trolley-footer van-hairline--top"
        v-show="shopingCartList.length"
      >
        <div class="dredge-tips" v-if="userInfo && userInfo.top_member">
          <open-member-tips :discounts="memberDiscount" />
        </div>
        <div class="shoping-trolley-footer-wrapper">
          <div class="check-all">
            <checkbox
              :checked="checkAllStatus"
              :disabled="false"
              :gid="-1"
              :platform="'checkAll'"
              @change="checkAll"
            ></checkbox>
            <span>全选</span>
          </div>
          <div class="product-total-price" v-show="!editPattern">
            <div class="total-price">
              <div class="total">
                <span>合计:</span>
                <div class="price">
                  ¥
                  <em>{{ totalPrice }}</em>
                </div>
              </div>
              <div class="shop-wealfare" v-show="totalRebate * 1">
                共返 {{ totalRebate }}
              </div>
            </div>
            <div class="settle-accounts">
              <button
                :disabled="!checkGoodsStatus"
                @click="settleAccounts"
                class="submit"
              >
                去结算
              </button>
            </div>
          </div>
          <div class="edit-btn" v-show="editPattern">
            <a @click="clearall" class="clear-all" href="javascript:;">
              清除所有
            </a>
            <a @click="appointDel" class="clear-selected" href="javascript:;">
              删除
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="shoping-cart-empty" v-show="isEmpty">
      <div class="empty-intro">
        <img alt src="../assets/img/shop-icon.png" />
        <p>购物车空空如也!</p>
        <router-link class="go-home" to="/home">去购物</router-link>
      </div>
      <div class="browsing-info" v-show="browsingList.length">
        <div class="browsing-tit">最近浏览</div>
        <div class="browsing-list">
          <product-single :list="browsingList" />
        </div>
      </div>
    </div>
    <edit-dialog
      @cancel-handler="EditCancelHandler"
      @confrim-handler="EditConfrimHandler"
      v-model="dialog.show"
    >
      <template #msg>{{ dialog.title }}</template>
    </edit-dialog>
    <edit-dialog
      @cancel-handler="delCancelHandler"
      @confrim-handler="delConfirmHandler"
      v-model="delSku.show"
    >
      <template #msg>{{ delSku.title }}</template>
    </edit-dialog>
  </div>
</template>

<script>
import { Stepper, Sticky } from 'vant'
import NavBar from '../components/NavBarForCart'
import Checkbox from '../components/Checkbox'
import Msg from '../components/shopingTrolley/Msg'
import EditDialog from '../components/Dialog'
import OpenMemberTips from '../components/OpenMemberTips'
import ProductSingle from '../components/ProductSingle'
import { mapActions, mapState, mapGetters } from 'vuex'
let flag = false
export default {
  name: 'shopingTrolley',
  components: {
    NavBar,
    Checkbox,
    Msg,
    Sticky,
    Stepper,
    EditDialog,
    OpenMemberTips,
    ProductSingle
  },
  data () {
    return {
      navBar: {
        title: '购物车',
        rightText: '编辑',
        showEdit: true,
        editPattern: true
      },
      current: 0,
      tabs: [
        { title: '个人购物车' },
        {
          title: '惠采购物车',
          url: `${process.env.VUE_APP_BASE_URL}qyhc/pages/cart/cart`
        }
      ],
      editPattern: false,
      result: [],
      isEmpty: false,
      dredgeMemberStatus: false,
      dialog: {
        show: false,
        title: '',
        confirmType: ''
      },
      delSku: {
        show: false,
        title: '确定要删除该商品么?'
      },
      showMsg: false,
      browsingList: [],
      noRecords: false,
      canUseGoldStatus: false
    }
  },
  computed: {
    ...mapState('store', [
      'userInfo'
    ]),
    ...mapGetters('shopingCart', ['checkGoodsStatus']),
    ...mapState('shopingCart', [
      'shopingCartList',
      'checkAllStatus',
      'totalPrice',
      'totalRebate',
      'memberTotalPrice',
      'memberTotalRebate',
      'memberDiscount'

    ])

  },
  filters: {
    viewPriceName (platform) {
      switch (platform) {
        case 'jd':
          return '京东'
        case 'yanxuan':
          return '网易'
        case 'suning':
          return '苏宁'
      }
    },

    skuStep (rule) {
      return rule === 'half_price' ? 2 : 1
    },

    skuMinNum (rule, min, skuNum) {
      return rule === 'half_price' ? 2 : skuNum < min ? skuNum : min
    }
  },
  created () {
    this.getShopingCartList()
      .then(() => {
        this.getCartPrice()
        this.showMsgHandler()
        this.getBrowsingList()
      })
  },
  methods: {
    ...mapActions('shopingCart', [
      'getShopingCartDetails',
      'getSkuNum',
      'getSkuCheckStatus',
      'getCheckAllStatus',
      'getDelSimpleSkuInfo',
      'delSomeSkuHandler',
      'clealAllHandler',
      'getCartTotalPrice'
    ]),
    switchTab (index) {
      if (index) {
        location.href = this.tabs[index].url
      }
    },
    showMsgHandler () {
      if (this.userInfo.level <= 1) {
        this.toggleShowMsgStatus()
      }
    },

    // 开通会员提示 显示/隐藏 切换
    toggleShowMsgStatus () {
      this.showMsg = !this.showMsg
    },

    // 查看jd价格
    viewJdPrice (platform) {
      this.$router.push({
        name: 'shopingTrolleyForJdList',
        query: { platform }
      })
    },

    // 跳转到商品详情
    jumpDetails (goodsid, skuid, platform) {
      this.$router.push({
        name: 'productDetails',
        query: { goodsid, skuid, platform }
      })
    },

    /**
     * 商品操作 加
     * @param { String } skuid 商品skuid
     * @param { Number } number 数量
     * @param { String } platform 平台标识
     */
    async skuPlus (sku) {
      this.$toast.loading('请稍候...')
      const res = await this.$axios.post('api/cart/2.0/add', { id: sku.sku_id })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code === 0 || code === 98) {
          this.getCartPrice()
          this.getSkuNum({
            skuid: sku.sku_id,
            number: sku.number,
            platform: sku.platform,
            ruleCode: sku.activity && sku.activity.rule.code,
            minNum: sku.lowest_buy,
            maxNum: sku.activity && sku.activity.per_num,
            type: 'add'
          })
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 商品操作减
     * @param { String } skuid 商品skuid
     * @param { Number } number 商品数量
     * @param { String } platform 平台标识
     * @param { String } ruleCode 商品折扣规则
     */
    async skuMinus (sku) {
      this.$toast.loading('请稍候...')
      const res = await this.$axios.post('api/cart/2.0/sub', { id: sku.sku_id })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code === 0) {
          this.getCartPrice()
          this.getSkuNum({ skuid: sku.sku_id, number: sku.number, platform: sku.platform, ruleCode: sku.activity && sku.activity.rule.code, type: 'sub' })
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 商品操作 直接修改数量
     * @param { String } skuid 商品skuid
     * @param { Number } number 数量
     * @param { String } platform 平台标识
     */
    async skuBlur (event, sku) {
      this.$toast.loading('请稍候...')
      const res = await this.$axios.post('api/cart/2.0/up', { id: sku.sku_id, num: event.target.value })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code === 0 || code === 98) {
          this.getCartPrice()
          this.getSkuNum({
            skuid: sku.sku_id,
            number: event.target.value,
            platform: sku.platform,
            ruleCode: sku.activity && sku.activity.rule.code,
            minNum: sku.lowest_buy,
            maxNum: sku.activity && sku.activity.per_num,
            type: 'up'
          })
        } else {
          this.$toast(msg)
        }
      }
    },

    // 加减禁用
    disabledEvent (event, ruleCode, count) {
      const str = event === 'plus' ? '最多' : '至少'
      if (ruleCode === 'half_price') {
        if (count <= 2) {
          this.$toast(`${str}购买2件`)
        }
      } else {
        this.$toast(`${str}购买${count}件`)
      }
    },

    // 确认删除(单个商品)
    async delConfirmHandler () {
      if (flag) {
        return false
      }
      flag = true

      const status = await this.delSimpleSkuHandler(
        this.delSku.skuid,
        this.delSku.platform
      )
      if (status) {
        this.delSku.show = false
      }
      flag = false
    },

    /**
     * 删除单个商品确认弹窗
     */
    delSimpleSku (skuid, platform) {
      this.delSku.show = true
      this.delSku.skuid = skuid
      this.delSku.platform = platform
    },

    /**
     * 取消删除单个商品
     */
    delCancelHandler () {
      this.delSku.show = false
    },

    /**
     * 删除单个商品
     * @param { String } skuid
     * @param { String } platform 商品平台
     */
    async delSimpleSkuHandler (skuid, platform) {
      const status = await this.editShopingCartHandler({ id: [skuid] })
      if (status) {
        await this.getDelSimpleSkuInfo({ skuid, platform })
        this.$toast('删除成功')
        if (!this.shopingCartList.length) {
          this.isEmpty = true
        }
      }
      return status
    },

    /**
     * 购物车编辑选项切换
     */
    toggleEditHandler () {
      this.editPattern = !this.editPattern
    },

    /**
     * 商品选中/取消
     */
    async skuCheckChange (e) {
      const { skuid, checkStatus } = e
      await this.goodsCheckHandler({
        sign: 'sku',
        sku_id: skuid,
        type: checkStatus ? 'select' : 'cancel'
      })
      await this.getSkuCheckStatus(e)
    },

    /**
     * 平台选中/取消
     */
    async checkChange (e) {
      const { platform, checkStatus } = e
      await this.goodsCheckHandler({
        sign: 'platform',
        platform,
        type: checkStatus ? 'select' : 'cancel'
      })
      await this.getSkuCheckStatus(e)
    },

    /**
     *  全选/反选
     */
    async checkAll (e) {
      const { checkStatus } = e
      await this.goodsCheckHandler({
        sign: 'all',
        type: checkStatus ? 'select' : 'cancel'
      })
      await this.getCheckAllStatus(e)
    },

    /**
     * 取消编辑
     */
    EditCancelHandler () {
      this.dialog.show = false
    },

    /**
     * 编辑弹窗确认
     */
    async EditConfrimHandler () {
      if (flag) {
        return
      }
      flag = true
      if (this.dialog.confirmType === 'clearAll') {
        const status = await this.editShopingCartHandler({ id: '' })
        if (status) {
          await this.clealAllHandler()
          this.isEmpty = true
          flag = false
        }
      } else if (this.dialog.confirmType === 'delSome') {
        let skuList = []
        this.shopingCartList.forEach(platform => {
          platform.sku_list.forEach(v => {
            if (v.checkStatus) {
              skuList.push(v.sku_id)
            }
          })
        })
        const status = await this.editShopingCartHandler({
          id: skuList.length ? skuList : ''
        })
        if (status) {
          await this.delSomeSkuHandler()
          if (!this.shopingCartList.length) {
            this.isEmpty = true
          }
          flag = false
        }
      }
      this.dialog.show = false
    },

    /**
     * 清空购物车
     */
    async clearall () {
      this.dialog = {
        show: true,
        title: '确认要清空购物车么?',
        confirmType: 'clearAll'
      }
    },

    /**
     * 购物车编辑删除
     */
    async appointDel () {
      if (this.checkGoodsStatus) {
        this.dialog = {
          show: true,
          title: '确认要删除选中商品么?',
          confirmType: 'delSome'
        }
      } else {
        this.$toast('请选择想要删除的商品')
      }
    },

    /**
     * 购物车编辑
     * @param {Array} skuList 选中的sku列表
     */
    async editShopingCartHandler (params) {
      const res = await this.$axios.post('api/cart/2.0/remove', params)
      if (res.status === 200) {
        const { code, msg } = res.data
        if (code === 0) {
          this.getCartPrice()
          return true
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 结算
     */
    async settleAccounts () {
      if (!this.checkGoodsStatus) {
        this.$toast('您还没选择商品哦')
        return false
      }
      this.createTempHandler()
    },

    /**
     * 购物车商品选择操作
     * @param { String } sku_id 商品ID
     * @param { String } sign 勾选类型  all 全选 platform 平台下商品全选  sku sku选择
     * @param { String } platform 平台类型
     * @param { String } type 勾选状态  select 选中  cancel 取消选中
     */
    async goodsCheckHandler (params) {
      this.$toast.loading('请稍候...')
      const res = await this.$axios.post('api/cart/2.0/select', params)
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg } = res.data
        if (code !== 0) {
          this.$toast(msg)
        } else {
          this.getCartPrice()
        }
      }
    },

    /**
     * 创建临时订单
     * @param{ String} type 临时订单类型  cart 购物车类型
     */
    async createTempHandler () {
      this.$toast.loading('正在创建订单,请稍候...')
      const res = await this.$axios.post('api/order/2.0/sto', { type: 'cart' })
      if (res.status === 200) {
        const { code, msg, data } = res.data
        this.$toast.clear()
        if (code === 0) {
          this.$router.push({ name: 'orderConfirm', query: { oid: data } })
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 获取购物车列表
     */
    async getShopingCartList () {
      this.$toast.loading('正在加载...')
      const res = await this.$axios.get('api/cart/2.0/list')
      if (res.status === 200) {
        const { code, msg, data } = res.data
        this.$toast.clear()
        if (code === 0) {
          this.canUseGoldStatus = data.user_flj
          this.getShopingCartDetails(data)
        } else if (code === 9006) {
          this.isEmpty = true
        } else if (code === -1) {
          this.isEmpty = true
        } else {
          this.isEmpty = true
          this.$toast(msg)
        }
      }
    },

    /**
     * 购物车金额计算
     */
    async getCartPrice () {
      const res = await this.$axios.get('api/cart/2.0/count')
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          this.getCartTotalPrice(data)
        } else if (code === 9006) {

        } else {
          this.$toast(msg)
        }
      }
    },

    /**
    * 获取浏览记录列表
   */
    async getBrowsingList () {
      const res = await this.$axios.get('api/goods/record')
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.browsingList = data
        } else if (code === 9006) {
          this.noRecords = true
        } else {
          this.$toast(msg)
        }
      }
    }

  }
}
</script>

<style lang="less">
.shoping-sku-stepper {
  .van-stepper__minus,
  .van-stepper__plus {
    width: 0.42rem;
    height: 0.42rem;
    background-color: transparent;
    border-radius: 50%;
    border: 0.02rem solid #d5d5d5;
    color: #646464;
  }
  .van-stepper__minus--disabled,
  .van-stepper__plus--disabled {
    background-color: transparent;
  }
  .van-stepper__minus:active,
  .van-stepper__plus:active,
  .van-stepper__input[disabled] {
    background-color: transparent;
  }
  .van-stepper__minus--disabled,
  .van-stepper__plus--disabled {
    color: #d5d5d5;
    // color: #646464;
  }
  .van-stepper__input[disabled] {
    color: #484848;
    -webkit-text-fill-color: #484848;
    -webkit-opacity: 1;
    opacity: 1;
    background-color: transparent;
  }
  .van-stepper__input {
    font-size: @fz28;
    color: #484848;
    font-weight: bold;
    background-color: transparent;
  }
}
</style>
<style lang="less" scoped>
  .tabs {
    .flex-between;
    background-color: #fff;
    .tab-item {
      flex: 1;
      height: .72rem;
      .flex-center;
      color: #3C3C3C;
      font-size: .26rem;

    }
    .current {
      position: relative;
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 0.66rem;
          height: 0.1rem;
         background-color:#FF3824;
        }
      }
  }
.shoping-trolley {
  padding-bottom: 1.2rem;
  position: relative;
  .shoping-trolley-wrapper {
    padding-bottom: 2.2rem;
  }
  .shoping-trolley-platfrom {
    margin-top: 0.24rem;
    background-color: #fff;
    .platform-title {
      position: relative;
      height: 0.8rem;
      display: flex;
      align-items: center;
      font-size: @fz28;
      color: @base;
      .platform-status {
        width: 0.86rem;
      }
      .view-jd-price {
        position: absolute;
        height: 100%;
        right: 0.3rem;
        top: 0;
      }
    }
    .platform-product-lists {
      .platform-product-lists-wrapper {
        .platform-product-details {
          .flex-between;
          .sku-checked {
            width: 0.86rem;
            // .flex-center;
          }
          .jump-details {
            width: 6.64rem;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
          }
          .sku-details {
            position: relative;
            padding: 0.24rem 0;
            width: 100%;
            display: flex;
            align-items: center;
            .sku-img {
              width: 1.6rem;
              height: 1.6rem;
              position: relative;
              img {
                object-fit: contain;
              }
              .sku-img-mask {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: 1.08rem;
                height: 1.08rem;
                font-size: @fz20;
                color: #fff9f9;
                border-radius: 50%;
                .flex-center;
                background-color: rgba(0, 0, 0, 0.7);
              }
            }
            .sku-intro {
              width: 4.1rem;
              padding-left: 0.2rem;
              min-height: 1.6rem;
              .flex-column-between;
              .sku-title {
                .ellipsis2;
                font-size: @fz24;
                color: @sku-tit;
              }
              .sku-hint {
                font-size: @fz22;
                color: @member-text;
                i{
                  color: #3cd407;
                }
                .red{
                  color: #FF3824;
                }
              }
              .sku-name {
                font-size: @fz20;
                color: #b8b8b8;
                display: flex;
                span {
                  .ellipsis1;
                  padding: 0.05rem 0.08rem;
                  background-color: #f5f5f5;
                  box-sizing: border-box;
                  border: 0.5px solid #cbcbcb;
                  border-radius: 0.05rem;
                }
              }
              .sku-price {
                font-size: @fz20;
                color: @price;
                em {
                  font-size: @fz28;
                }
              }
            }
          }
          .sku-stepper {
            position: absolute;
            right: 0.3rem;
            bottom: 0.24rem;
            display: flex;
            align-items: center;
            .sku-tips {
              color: #ff3824;
              font-size: 0.24rem;
              margin-right: 0.2rem;
            }
          }
          .del-simple-sku {
            position: absolute;
            top: 0.25rem;
            right: 0.25rem;
            width: 0.34rem;
            height: 0.28rem;
            background: url('../assets/img/del.png') center no-repeat;
            background-size: 100%;
          }
          .sku-status {
            width: 4.52rem;
            height: 0.44rem;
            background-color: #ffecbb;
            color: #8b572a;
            font-size: @fz20;
            border-radius: 30px;
            margin: 0 0.26rem 0.15rem 0;
            display: flex;
            align-items: center;
            span {
              width: 0.32rem;
              height: 0.32rem;
              margin-left: 0.07rem;
              margin-right: 0.09rem;
              background: url('../assets/img/mark.png') center no-repeat;
              background-size: 100%;
            }
          }
        }
      }
    }
  }

  .dredge-tips {
    width: 100%;
  }
  .shoping-trolley-footer {
    position: fixed;
    width: 100%;
    bottom: 1rem;
    background-color: #fff;
    font-size: @fz28;
    .safe-area-inset-bottom;
    .shoping-trolley-footer-wrapper {
      width: 100%;
      height: 1.2rem;
      .flex-between;
      font-size: @fz28;
    }
    .check-all {
      height: 100%;
      .flex-center;
      padding-left: 0.32rem;
      span {
        padding-left: 0.32rem;
      }
    }
    .product-total-price {
      display: flex;
      height: 100%;
      .total-price {
        padding-right: 0.25rem;
        .flex-column-center-center;
      }
      .total {
        color: @base;
        .flex-center;
        span {
          padding-right: 0.3rem;
        }
        .price {
          color: @price;
          font-size: @fz22;
          em {
            font-size: @fz32;
          }
        }
      }
      .shop-wealfare {
        font-size: @fz22;
        color: #ff7163;
        text-align: right;
      }
    }
    .settle-accounts {
      width: 1.72rem;
      height: 100%;
      color: #fff;
      .flex-center;
      button {
        width: 100%;
        height: 100%;
        background-color: #ff3824;

        &:disabled {
          background-color: #FFA400;
          // background-color: #333;
        }
      }
    }
    .edit-btn {
      display: flex;
      margin-right: 0.2rem;
      a {
        width: 1.48rem;
        height: 0.6rem;
        font-size: 0.24rem;
        color: #f5a623;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffe1af;
        border: 1px solid #f5a623;
        box-sizing: border-box;
        border-radius: 30px;
      }
      .clear-all {
        margin-right: 0.24rem;
      }
      .clear-selected {
        color: #808080;
        border-color: #bdbdbd;
        background-color: #f4f4f4;
      }
    }
  }
  .shoping-cart-empty {
    margin-top: .2rem;
    .empty-intro {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-top: 1.7rem;
      padding-bottom: 0.8rem;
      background-color: #fff;
    }

    img {
      width: 4.49rem;
      height: 2.98rem;
    }
    p {
      font-size: @fz28;
      color: @c80;
      margin-top: -0.7rem;
    }
    .go-home {
      width: 1.93rem;
      height: 0.6rem;
      margin: 0.6rem auto 0;
      .flex-center;
      border: 0.5px solid #979797;
      background-color: #fff;
      border-radius: 30px;
      color: @base;
      font-size: @fz24;
    }
  }
  .browsing-info {
    .browsing-tit {
      position: relative;
      margin: 0.5rem 0 0.3rem;
      font-size: @fz32;
      color: #979797;
      text-align: center;
      &::after,
      &::before {
        content: '';
        position: absolute;
        width: 1.1rem;
        height: 1px;
        background-color: #979797;
        top: 50%;
        transform: translateY(-50%);
      }
      &::after {
        left: 1.5rem;
      }
      &::before {
        right: 1.5rem;
      }
    }
    .browsing-list {
      padding: 0 0.2rem 1rem;
    }
  }
}
</style>
